import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
  standalone: false
})
export class InitialsPipe implements PipeTransform {
  transform(name: string): string {
    if (!name) return '';
    return name
      .split(' ')
      .filter(w => w.trim().length > 0)
      .map(w => w.trim()[0].toUpperCase())
      .join('');
  }
}